import { isNil, isString, size, split } from 'lodash/fp'
import { customTranslations } from './customTranslations'
// import log from 'loglevel'

export const customTranslates = (
  product: string,
  key: string,
  options: Record<string, any>,
  defaultTranslate: (key: string, options: Record<string, any>) => string
): string => {
  const env = process.env['REACT_APP_ENV']
  const custom =
    customTranslations[env as keyof typeof customTranslations][product]
  if (isNil(custom)) return defaultTranslate(key, options)
  const items = split('.')(key)
  let customItem = custom
  for (let i = 0; i < size(items); i++) {
    const tmp = customItem[items[i]]
    if (isNil(tmp)) break
    if (i + 1 === size(items) || !isString(tmp)) {
      customItem = tmp
      continue
    }
    customItem = customItem[`${items[i] as string}.${items[i + 1] as string}`]
    if (isNil(customItem)) break
  }
  return !isNil(customItem) && isString(customItem)
    ? customItem
    : defaultTranslate(key, options)
}
